import objectFitImages from 'object-fit-images';
import WistiaHelper from '../../common/gdpr/wistia-helper';

import ScreenshotsTracker from './screenshots/screenshots-tracker';
import BoardsTrialAction from './screenshots/boards-trial';
import BoardsDemoAction from './screenshots/boards-demo';
import GanttDemoAction from './screenshots/gantt-demo';
import WG from '../../common/modules/wg';
import merge from 'lodash.merge';

require('../../vendor/swiper');

require('./includes/tabs');
require('./includes/modal-form');
require('./screenshots/modal-form');
require('./includes/customers-slider');

(function(global) {
    let solutionsMinHeight = 0;
    let styleID = '#solutions-style';

    if (!$(styleID).length) {
        $('head').append('<style id="solutions-style"/>');
    }

    let solutionsStyle = $(styleID);

    function addDesktopViewClassOnCustomersCards() {
        if (!window.isMobile.any) {
            $('.home-customers').addClass('desktop-view');
        }
    }

    function setMinHeight() {
        if (window.innerWidth < 768) {
            solutionsStyle.text('');
        } else {
            solutionsStyle.text('.wrike-solutions__card-wrap { min-height: ' + solutionsMinHeight + 'px !important }');
        }
    }

    function onResize() {
        solutionsMinHeight = 0;

        window.requestAnimationFrame(function() {
            $('.wrike-solutions__card').each(function(i, card) {
                let height = $(card).outerHeight();

                if ($(card).outerHeight() > solutionsMinHeight) {
                    solutionsMinHeight = Math.round(height);
                }
            });
            setMinHeight();
        });
    }
    function solutionsCardsMinHeight() {
        $(window).resize(function() {
            onResize();
        });
    }
    function initWistia() {
        let $modalVideo = $('#modalVideo');
        let wistiaId = $modalVideo.data('wistia-id');
        let $valuesVideo = $('#valuesVideo');
        let $demoVideo = $('#demoVideo');
        let valuesWistiaId = $valuesVideo.data('wistia-id');
        let demoWistiaId = $demoVideo.data('wistia-id');

        $modalVideo.on('show.wg.modal', function() {
            WG.GdprUserCentrics.makeConditionalCallback(() => {
                WistiaHelper.appendWistiaVideo($modalVideo, wistiaId, '', '');
            }, WG.GdprUserCentrics.ConsentCategories.Advertising)();
        });

        $valuesVideo.on('show.wg.modal', function() {
            WG.GdprUserCentrics.makeConditionalCallback(() => {
                WistiaHelper.appendWistiaVideo($valuesVideo, valuesWistiaId, '', '');
            }, WG.GdprUserCentrics.ConsentCategories.Advertising)();
        });

        $demoVideo.on('show.wg.modal', function() {
            WG.GdprUserCentrics.makeConditionalCallback(() => {
                WistiaHelper.appendWistiaVideo($demoVideo, demoWistiaId, '', '');
            }, WG.GdprUserCentrics.ConsentCategories.Advertising)();
        });

        $modalVideo
            .add($valuesVideo)
            .add($demoVideo)
            .on('hide.wg.modal', function() {
                $(this)
                    .find('.wistia_responsive_padding')
                    .detach();
            });
    }

    function initScreenshotsTracking() {
        if (!('screenshotsWidgetTracking' in window) || !window.screenshotsWidgetTracking) {
            return;
        }

        const tracker = new ScreenshotsTracker();

        const trackings = [
            {
                screenshot: 'interactive-screenshot-boards',
                events: ['IS_BOARDS__TASK_MOVED'],
                action: BoardsTrialAction,
                type: 'trial'
            },
            {
                screenshot: 'interactive-screenshot-boards',
                events: ['IS_BOARDS__TASK_MOVED'],
                action: BoardsDemoAction,
                type: 'demo'
            },
            {
                screenshot: 'interactive-screenshot-gantt-chart',
                events: ['IS_GANTT_CHART__TASK_MOVED', 'IS_GANTT_CHART__TASK_RESIZED'],
                action: GanttDemoAction,
                type: 'demo'
            }
        ];

        trackings.forEach((tracking) => tracker.set(tracking));
    }

    function initAirPrTracking() {
        const $trialForm = $('.home-intro__form');
        const $trialInput = $('.home-intro__input');

        $trialForm.on('success.wg.registration', () => {
            const addons = $trialForm.data('addons');
            const packages = $trialForm.data('packages');
            const onboarding = $trialForm.data('onboarding');

            const defaultData = {
                value: {
                    email: $trialInput.val(),
                    form: $trialForm.data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons,
                    packages,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteData = {
                group: 'trial_forms',
                event: 'trial_form__submit',
                path: window.location.pathname
            };

            const airPrData = {
                event: 'trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteData));
            new WG.AirPrTracking(merge(defaultData, airPrData));
        });

        $trialForm.on('user.exist.wg.success.registration', () => {
            const addons = $trialForm.data('addons');
            const packages = $trialForm.data('packages');
            const onboarding = $trialForm.data('onboarding');

            const defaultData = {
                value: {
                    email: $trialInput.val(),
                    form: $trialForm.data('hash'),
                    plan: $trialForm.data('plan') || 'BIZ_2021',
                    addons,
                    packages,
                    onboarding,
                    c_email: window.wrike.cEmail || 'null',
                    existing_user: window.wrike.isUserExisting
                }
            };

            const statSiteDataForExistedUser = {
                group: 'exist_user_form_submit',
                event: 'exist_trial_form__submit',
                path: window.location.pathname
            };

            const airPrDataForExistedUser = {
                event: 'exist_trial_form__submitted'
            };

            global.trackEventForm(merge(defaultData, statSiteDataForExistedUser));
            new WG.AirPrTracking(merge(defaultData, airPrDataForExistedUser));
        });
    }

    $(function() {
        $('.wg-header')
            .wgInstance()
            .setTheme('dark');

        const tabs = new global.Tabs();
        const customersSlider = new global.CustomersSlider();

        tabs.init();
        customersSlider.init();

        initWistia();
        onResize();
        solutionsCardsMinHeight();
        addDesktopViewClassOnCustomersCards();
        objectFitImages();
        initScreenshotsTracking();
        initAirPrTracking();
    });
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/home-enterprise.js